import React, { useContext } from 'react';

type ContextType = boolean;

const initialContext: ContextType = false;
const IsMultiselectContext = React.createContext<ContextType>(initialContext);

export const useIsMultiselect = () => useContext(IsMultiselectContext);

export default IsMultiselectContext;
